export const CookieConsent = ".Crowlyn.CookieConsent";
export const CrowlynRequestVerificationToken =
  ".Crowlyn.RequestVerificationToken";
export const CrowlynRequestId = ".Crowlyn.RequestId";
